import { Popover as Bs5Popover } from 'react-bootstrap5';

export default Bs5Popover;
